import { render, staticRenderFns } from "./modalDokumenEdit.vue?vue&type=template&id=50824144&"
import script from "./modalDokumenEdit.vue?vue&type=script&lang=js&"
export * from "./modalDokumenEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports